import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import "../css/signIn.css";

const SignIn: React.FC = () => {
    const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  const SINGLE_USER_NAME = process.env.REACT_APP_SINGLE_USER_NAME;
  const SINGLE_USER_PASSWORD = process.env.REACT_APP_SINGLE_USER_PASSWORD;

  const handleSignIn = async () => {
    try {
      if (username === SINGLE_USER_NAME && password === SINGLE_USER_PASSWORD) {
        const token = btoa(`${username}:${password}`);
        
        localStorage.setItem('jwtToken', token);

        navigate('/editor');
      } else {
        throw new Error('Invalid credentials');
      }
    } catch (err) {
      setError('Failed to sign in');
      console.error(err);
    }
  };

  return (
    <div className='content'>

    <div className="signin-container">
      <h1 className="signin-title">Sign In</h1>
      {error && <p className="error-message">{error}</p>}
      <input
        type="text"
        placeholder="Username"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
        className="signin-input"
        />
      <input
        type="password"
        placeholder="Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        className="signin-input"
        />
      <button onClick={handleSignIn} className="signin-button">Sign In</button>
    </div>
        </div>
  );
};

export default SignIn;